import React, { useState } from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import FormValidationSummary, { mergeValidationErrors, validationMessage } from '../../../Shared/Components/FormValidationSummary'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'

const Reqd = () => <span className="text-danger">*</span>

const StatusCatalogForm = ({ item, reportBucketLabels }) => {
    const { flash, errors: pageErrors } = usePage().props
    const isEdit = Boolean(item)
    const [saving, setSaving] = useState(false)

    const form = useForm({
        name: item?.name || '',
        report_bucket: item?.report_bucket || 'none',
        sort_order: item?.sort_order ?? 0,
        activo: item?.activo !== false,
    })

    const allErrors = mergeValidationErrors(form.errors, pageErrors)
    const fieldError = (key) => validationMessage(allErrors, key)
    const invalidClass = (key) => (fieldError(key) ? 'is-invalid' : '')
    const FieldFeedback = ({ name }) =>
        fieldError(name) ? <div className="invalid-feedback d-block">{fieldError(name)}</div> : null

    const submit = (e) => {
        e.preventDefault()
        setSaving(true)
        const opts = { preserveScroll: true, onFinish: () => setSaving(false) }

        if (isEdit) {
            form.put(route('secom.catalogs.update', item.id), opts)
        } else {
            form.post(route('secom.catalogs.store'), opts)
        }
    }

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <FormValidationSummary errors={allErrors} />
            <span className="pb-7 pt-7">
                <Breadcrumbs
                    currentPath={
                        isEdit ? `admin/secom/catalogos/status/${item.id}/edit` : 'admin/secom/catalogos/status/create'
                    }
                />
            </span>

            <Card className="card-flush shadow-sm mb-10">
                <Card.Header className="pt-7">
                    <Card.Title className="fw-bold text-gray-800">
                        {isEdit ? 'Editar status' : 'Nuevo status'}
                    </Card.Title>
                </Card.Header>
                <Card.Body className="py-8 px-6 px-lg-10">
                    <Form onSubmit={submit}>
                        <Row className="g-6">
                            <Col md={6}>
                                <div className="mb-4">
                                    <Form.Label className="fw-bold">
                                        Nombre <Reqd />
                                    </Form.Label>
                                    <Form.Control
                                        value={form.data.name}
                                        onChange={(e) => form.setData('name', e.target.value)}
                                        className={invalidClass('name')}
                                    />
                                    <FieldFeedback name="name" />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-4">
                                    <Form.Label className="fw-bold">
                                        Agrupación en reporte <Reqd />
                                    </Form.Label>
                                    <Form.Select
                                        value={form.data.report_bucket}
                                        onChange={(e) => form.setData('report_bucket', e.target.value)}
                                        className={invalidClass('report_bucket')}
                                    >
                                        {Object.entries(reportBucketLabels).map(([value, label]) => (
                                            <option key={value} value={value}>
                                                {label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <FieldFeedback name="report_bucket" />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-4">
                                    <Form.Label className="fw-bold">
                                        Orden <Reqd />
                                    </Form.Label>
                                    <Form.Control
                                        type="number"
                                        min={0}
                                        value={form.data.sort_order}
                                        onChange={(e) => form.setData('sort_order', e.target.value)}
                                        className={invalidClass('sort_order')}
                                    />
                                    <FieldFeedback name="sort_order" />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-4 pt-8">
                                    <Form.Check
                                        type="switch"
                                        id="activo"
                                        label="Activo"
                                        checked={form.data.activo}
                                        onChange={(e) => form.setData('activo', e.target.checked)}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <div className="d-flex gap-3 mt-6">
                            <Button type="submit" variant="primary" disabled={saving || form.processing}>
                                {saving ? 'Guardando…' : 'Guardar'}
                            </Button>
                            <Link href={route('secom.catalogs.index')} className="btn btn-light">
                                Cancelar
                            </Link>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </Row>
    )
}

StatusCatalogForm.layout = (page) => <Layout title="SECOM — Catálogo de status">{page}</Layout>

export default StatusCatalogForm
